import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
import momentTimeZone from "moment-timezone";
import { Notification } from "@vds/notifications";
import * as Actions from "../../store/actions/global/global";
import PropTypes from "prop-types";

function NotificationBanner(props) {
  const [bannerInfo, setBannerInfo] = useState({});
  const remainingTime = 3600000; // 60 minutes
  const { t } = useTranslation("loginTranslation");

  useEffect(() => {
    setBannerInfo(props.bannerMessage);

    let startTime = props.bannerMessage.startTime;
    let start = convertUTCDateToLocalDate(startTime);
    let current = currentDateTimeInLocalTime();
    let ms = moment(start, "DD-MM-YYYY HH:mm:ss").diff(moment(current, "DD-MM-YYYY HH:mm:ss"));
    let duration = moment.duration(ms).asMilliseconds();

    if (duration <= remainingTime) {
      let remainingTimeToEndBanner = duration + 5000; // display maintenance after 5 seconds
      setTimeout(function () {
        props.setBannerDisplayOnLanding(false);
        props.setBannerDisplayOnAll(false);
      }, remainingTimeToEndBanner);
    }
  }, [props.bannerMessage]);

  const convertUTCDateToLocalDate = (date) => {
    const dates = moment(date).utc().format();
    const locals = moment.utc(dates).local().format();
    return locals;
  };
  const currentDateTimeInLocalTime = () => {
    const date = moment.utc().format();
    const local = moment.utc(date).local().format();
    return local;
  };

  const compareDate = (startTime, endTime) => {
    let first = moment(startTime);
    let second = moment(endTime);
    let duration = second.diff(first, "hours");
    let hoursDiff;

    if (duration < 24) {
      hoursDiff = true;
    } else {
      hoursDiff = false;
    }
    return hoursDiff;
  };

  const formatDate = (date) => {
    const dates = moment(date).utc().format();
    const locals = moment.utc(dates).local().format("dddd MMMM D, YYYY; h:mm A");
    return locals;
  };

  const timeZone = () => {
    let value = momentTimeZone().tz(moment.tz.guess()).format("z");
    return value;
  };

  return (
    <Notification
      type="warning"
      // title={`System maintenance is scheduled for ${compareDate(bannerInfo.startTime, bannerInfo.endTime) ?
      // 	formatDate(bannerInfo.startTime) + " - " + moment(bannerInfo.endTime).utc().local().format("h:mm A ") + timeZone() +". ":
      // 	formatDate(bannerInfo.startTime) + " - " + moment(bannerInfo.endTime).utc().local().format("dddd MMMM D, h:mm A ") + timeZone()+". "}
      // 	Users may have difficulties accessing the Customer Portal.`}
      // id={props.userLanguage === "en-US" ? "bannerContainer_en" : "bannerContainer_de_fr_nl"}
      title={t(`Notification Banner`, {
        time: `${
          compareDate(bannerInfo.startTime, bannerInfo.endTime)
            ? formatDate(bannerInfo.startTime) + " - " + moment(bannerInfo.endTime).utc().local().format("h:mm A ") + timeZone()
            : formatDate(bannerInfo.startTime) + " - " + moment(bannerInfo.endTime).utc().local().format("dddd MMMM D, h:mm A ") + timeZone()
        }`,
      })}
      layout="vertical"
      fullBleed={true}
      inlineTreatment={false}
      hideCloseButton={true}
      role="banner"
      aria-label="Verizon Connect, GPS Fleet Tracking System"
    />
  );
}

const mapStateToProps = (state) => {
  return {
    bannerMessage: state.ACCOUNT.bannerMessage,
    displayPlannedMaintenance: state.ACCOUNT.displayPlannedMaintenance,
    userLanguage: state.ACCOUNT.userLanguage,
  };
};

const mapDispatchToProps = {
  setBannerDisplayOnLanding: Actions.setBannerDisplayOnLanding,
  setBannerDisplayOnAll: Actions.setBannerDisplayOnAll,
  getPlannedMaintenance: Actions.getPlannedMaintenance,
};

NotificationBanner.propTypes = {
  bannerMessage: PropTypes.shape({
    startTime: PropTypes.string,
    endTime: PropTypes.string,
  }).isRequired,
  setBannerDisplayOnLanding: PropTypes.func.isRequired,
  setBannerDisplayOnAll: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationBanner);
